/**
 * Hear Control V1 mock constants (OS pipeline, patient journey, periods).
 */

export const OS_STAGES = [
  "Recebida",
  "Triagem",
  "Orçamento",
  "Aguardando peça",
  "Em reparo",
  "Pronta",
  "Entregue",
];

export const JOURNEY_CHIPS = [
  "Em avaliação",
  "Em teste",
  "Adaptado",
  "Retorno",
  "Inativo",
];

/** Wire values for PATCH /atendimentos/:id (wave-2 F3). */
export const ATENDIMENTO_STATUSES = [
  "Agendado",
  "Em atendimento",
  "Não compareceu",
  "Em teste",
  "Vendido",
  "Devolvido",
  "Cancelado",
  "Remarcado",
];

/** Operational status controls on Consulta ribbon (subset of catalog). */
export const ATENDIMENTO_STATUS_OPS = [
  "Em atendimento",
  "Não compareceu",
  "Em teste",
  "Vendido",
];

export const PERIOD_KEYS = ["mes", "trimestre", "ano"];

export const PERIOD_LABELS = {
  mes: "Mês",
  trimestre: "Trimestre",
  ano: "Ano",
};

export const FIXTURE_KEYS = {
  painel: "painel",
  atendimentos: "atendimentos",
  consulta: "consulta",
  pacientes: "pacientes",
  manutencoes: "manutencoes",
  configuracoes: "configuracoes",
  configuracoesEquipe: "configuracoes-equipe",
  configuracoesOrganizacao: "configuracoes-organizacao",
  /** Overlay cru por clínica (`hear_mock_access_policy`). */
  accessPolicy: "access_policy",
  /** Parâmetros operacionais por clínica (`hear_mock_configuration_parameters`). */
  configuracoesParametros: "configuration_parameters",
  /** Lead Control pairing status (`hear_mock_lead_control`). */
  leadControl: "lead_control",
  catalogo: "catalogo",
  /** Import jobs (`hear_mock_catalog_import`). One processing job per clinic. */
  catalogImport: "catalog_import",
  partnersImport: "partners_import",
  /** Commercial partners (`hear_mock_partners`). Isolated by session companyID. */
  parceiros: "partners",
  /** Attendance registers (`hear_mock_registros`). Isolated by session companyID. */
  registros: "registros",
  descontos: "descontos",
  organizacoes: "organizacoes",
  exams: "exams",
  documents: "documents",
};

export const CATALOG_TIPOS = ["AASI", "acessorio", "servico"];

export const DISCOUNT_TIPOS = ["percentual", "valor_fixo"];

export const DISCOUNT_ESCOPOS = ["todos", "skus", "tipo"];

/** Organization (Cadastro) types — institutional master data. */
export const ORG_TIPOS = [
  "empresa",
  "associacao",
  "orgao_publico",
  "clinica",
  "outro",
];

/** Organization vínculo types with the hearing center. */
export const ORG_VINCULOS = [
  "cooperacao",
  "convenio",
  "encaminhamento",
  "fornecimento",
  "educacao",
  "outro",
];

/** Structured commercial condition types (empresa + fornecimento only). */
export const ORG_CONDICAO_TIPOS = ["percentual", "valor_fixo", "tabela"];

export const EXAM_ALLOWED_MIME = [
  "application/pdf",
  "image/jpeg",
  "image/png",
];

export const EXAM_MAX_BYTES = 10 * 1024 * 1024;

/** Profile photo origin MIME (must not reuse EXAM_MAX_BYTES in photo copy). */
export const PHOTO_ALLOWED_MIME = ["image/jpeg", "image/png"];

/** Profile photo origin/export ceiling (5 MB). MUST NOT reuse EXAM_MAX_BYTES. */
export const PHOTO_MAX_BYTES = 5242880;

export const MOCK_STORAGE_PREFIX = "hear_mock_";
